export const PowerBtn = (props) => {
  return (  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={800}
    height={800}
    viewBox="0 0 46.032 46.033"
    {...props}
  >
    <path d="m8.532 18.531 8.955-8.999a2.708 2.708 0 0 0-4.49-1.062L1.047 20.479a3.596 3.596 0 0 0 0 5.073l11.949 12.01a2.71 2.71 0 0 0 4.491-1.06l-8.956-9c-2.461-2.475-2.46-6.499.001-8.971z" />
    <path d="M45.973 31.64c-1.396-5.957-5.771-14.256-18.906-16.01v-5.252a2.708 2.708 0 0 0-4.626-1.909L10.49 20.479a3.597 3.597 0 0 0-.001 5.073l11.95 12.009a2.702 2.702 0 0 0 2.951.592 2.707 2.707 0 0 0 1.676-2.5V30.57c4.494.004 10.963.596 15.564 3.463a2.223 2.223 0 0 0 2.473-.08 2.217 2.217 0 0 0 .87-2.313z" />
  </svg>
  )
}

export const Github = (props) => {
    return (
        <svg
          aria-hidden="true"
          data-prefix="fab"
          data-icon="github"
          className="prefix__svg-inline--fa prefix__fa-github prefix__fa-w-16"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 496 512"
          {...props}
        >
          <path
            fill={props.fill}
            d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
          />
        </svg>
      )
}

export const Twitter = (props) => {
    return (
        <svg
          aria-hidden="true"
          data-prefix="fab"
          data-icon="twitter"
          className="prefix__svg-inline--fa prefix__fa-twitter prefix__fa-w-16"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          {...props}
        >
          <path
            fill={props.fill}
            d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
          />
        </svg>
      )
}

export const Threads = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1040}
    height={1040}
    viewBox="0 0 780 780"
    {...props}
  >
    <path d="M370.5 28.6c-19.8 1.9-27.6 2.8-37.8 4.4-6.5 1.1-12.1 2.2-12.6 2.4-.4.3-3.2 1-6.2 1.5-29.5 5.2-70.3 21.8-97.9 39.9-16.2 10.5-29.1 21.5-46.6 39.4-16.7 17.3-21.6 23.6-37.1 48.5-5.3 8.5-10.1 15.3-11 15.3-1 0-1.2.6-.8 2 .4 1.3-1 5.4-4 11.7-5.1 10.6-9.2 20.5-12.3 29.9-1.1 3.2-3 8.4-4.2 11.4-1.9 4.9-8.6 30.6-12.5 48-3.4 14.6-8.2 48.7-9 62.5-.3 5.5-1 16.7-1.7 25-1.1 15.6-.6 38.3 1.7 73.5.8 12.4 3.4 33.5 5 41 .8 3.6 2.4 11.4 3.5 17.5 2.7 14.7 7.8 36.3 9.5 40 .7 1.6 2.5 7 4 12 2.6 8.7 3.8 12.2 10.5 29 3.5 8.6 9.1 20.3 13.5 28.1 3.4 6 19.7 31.7 20.5 32.4.4.3 2 2.5 3.7 5 1.7 2.5 4.4 5.9 5.9 7.6 1.6 1.7 6.3 7 10.4 11.8 8.4 9.9 24.5 24.7 38 34.9 13.9 10.5 36.7 23.8 49.8 29 2.3.9 4.5 2.4 4.8 3.2.4.8 1.6 1.5 2.9 1.5 1.2 0 6 1.4 10.6 3 11.8 4.2 41.8 12.6 51.4 14.3 22.4 4.1 31.4 5.2 57.4 6.8 17.6 1.1 22.6 1 53.6-1.1 29.8-2.1 58-7.4 81-15.2 20.5-6.9 55.6-24.9 70.2-35.9 2.9-2.1 5.7-3.9 6.3-3.9.6 0 1.3-.6 1.6-1.4.3-.8 4.4-4.5 9.2-8.4 12.5-10 18.5-16.1 29.8-30.2 13-16.4 14-17.8 20.8-29.1 10.5-17.8 20.1-43.1 23.6-62.4 3.3-18.4 4.5-37.8 3.1-51.6-3.3-33.7-12.4-61.7-27.7-84.9-8.8-13.4-15.2-21.5-23.1-29.1-17.5-16.7-34.4-28.9-54.9-39.3-7-3.6-13.1-7.1-13.6-7.8-.4-.7-.7-4.5-.7-8.3.1-7.2 0-8.3-3.1-25-6.3-33.8-14.6-53.1-32.6-75.8-20.1-25.3-49.7-43-83.2-49.6-5.7-1.2-12.9-2.3-16-2.6-3.1-.3-9.6-1-14.4-1.5-13.6-1.6-43.9 2.1-63.6 7.6-14.2 4-39.3 17.7-51.6 28.1-3.7 3.2-7.8 6.4-9 7.2-3.7 2.4-20.6 24.5-20.6 27 0 .5 5.1 4.4 11.3 8.6 14.1 9.5 25.7 17.6 32.3 22.6 7.4 5.7 9.7 5.3 15.7-2.1 5.8-7.3 16.5-16.3 22.7-19.1 2.5-1.1 5.2-2.5 6-3 19.9-12.5 68.4-13 93.6-.9 8.4 4 22.4 15.3 27.7 22.4 6.1 7.9 19.3 42.4 17.1 44.6-.6.6-6.6.3-14.9-.6-15.8-1.7-66.3-2.4-79.5-1.1-40 3.9-63.5 11.7-90.2 30-8.1 5.5-21.5 18.1-26.9 25.2-1.3 1.6-2.6 3.2-2.9 3.5-1.9 1.5-8.5 13.7-11.6 21.3-8.6 21.1-11.3 42.5-8 63.3 2 12.8 2.7 15.4 6.7 25.4 4.1 10.2 7.7 17.4 9.7 19.6 1 1.1 3.2 3.9 4.9 6.4 7.4 10.6 24.5 25.9 37.1 33.3 12.4 7.3 27.8 13 46.2 17.3 3.6.8 7.7 1.5 9.2 1.5 1.5-.1 4.9.4 7.5 1 8.1 1.8 27.9 1.1 46.3-1.6 17.6-2.6 23.5-3.7 26.5-5 29.2-12.2 35.6-15.8 50.8-28.5 9.2-7.6 24.4-27.2 32.6-42 8.5-15.2 17-40.8 20.6-62 .9-5.2 2-9.9 2.5-10.4 1.9-1.9 22.4 14.3 21.4 16.9-.4.9 0 1.2 1.3.9 2.4-.7 17 18.1 21.8 28 6.4 13.4 10.1 30 11.2 51.1 1 17.8-6 45.9-15.7 63.2-8.2 14.6-14.1 22.1-28.1 35.8-19.8 19.3-36.2 31.1-54.5 38.9-4.9 2.1-10.7 4.7-12.9 5.6-12.5 5.5-32 10.2-54.5 13.2-24.6 3.3-75.7 3.5-94 .3-1.4-.2-6-.9-10.3-1.4-16.7-2.3-48.2-11.5-62.7-18.3-4.7-2.2-10.7-5.1-13.5-6.4-8.3-4-40.1-27.3-49.6-36.4-3.2-3.1-20.8-25.8-25.9-33.4-7-10.5-17.8-31.6-23-45.1-2.4-6.1-4.9-12.4-5.6-14-4.3-10.4-13.9-51.8-15.9-68.5-.3-3-.9-6.9-1.1-8.5-.8-4.8-1.3-10.3-2-20-.3-5-.7-10.6-.9-12.5-1.3-10.8-1.7-47.5-.6-56.5.6-5.5 1.1-12.5 1.2-15.5.2-21.9 11-79.5 18.8-100.7 9.7-26.2 14.8-37.7 22.8-50.8 3-5 5.9-9.9 6.6-11 3-5 8.3-12.4 12.1-16.7 11.1-12.8 18-19.8 19.6-19.8 1 0 2-1 2.4-2.3 1.1-4.4 25.6-21.8 46.8-33.1 21.9-11.8 64.3-22.7 95.8-24.7 6.9-.4 16.8-1.1 22.1-1.5 11.7-.8 40.7 1 57.4 3.7 21.9 3.4 57.6 12.8 61 16 .5.5 1.7.9 2.7.9 2.8 0 27.2 12.8 38.8 20.4 5.8 3.8 13.9 9.7 18 13.1 9 7.5 26.4 25.9 34 36.1 9.6 12.7 23.3 36.7 29 50.9.5 1.1 1.8 4.1 2.9 6.6 1.2 2.5 2.1 5.3 2.1 6.2 0 1 .5 2.5 1.1 3.5.6.9 2.7 6.6 4.8 12.7 3.6 10.7 3.8 11 6.6 10.9 5.5-.2 11.1-1.3 23.1-4.7 6.5-1.9 17.6-4.9 24.7-6.8 9.5-2.5 12.7-3.7 12.7-4.9 0-2.4-10.3-32.5-14.4-41.8-2-4.6-3.6-8.8-3.6-9.3 0-1-6.3-13.8-14-28.4-6.4-12.2-11.1-19.4-26.6-41-4.9-6.9-27.8-30.5-37.4-38.5-3.6-3-6.7-5.8-7-6.1-1.1-1.3-17.1-12.8-26-18.7-15.5-10.2-45.5-24-65.5-30.1-23.8-7.2-45.5-12.1-63-14.1-5.5-.6-11.3-1.3-13-1.6-4.1-.6-64.1-1.3-69-.8zm94 378.4c8.8 1.1 18.5 2.3 21.5 2.5 7.1.5 8.3 2.1 7.4 9.5-1.8 15.6-8.5 43.3-12.3 50.9-7.4 14.8-10.4 19.1-20.4 28.7-10.8 10.6-13.5 12.2-28.7 17.4-23.2 7.9-57.8 5.8-79.7-5-19-9.4-30.3-25.9-30.3-44.5 0-14.6 4.5-25 16-36.6 5.9-6 9.5-8.5 16.9-12.2 6-3.1 10.6-4.7 13-4.7 2 0 4.1-.4 4.7-1 .9-.9 21.1-5.2 28.9-6.2 1.7-.2 12.9-.5 25-.6 17.3-.2 25.4.2 38 1.8z" />
    <path d="M586 604.5c0 .5.5 1.7 1 2.5s1 1 1 .5c0-.6-.5-1.7-1-2.5s-1-1.1-1-.5z" />
  </svg>
)

export const YouTube = (props) => {
    return (
        <svg
          aria-hidden="true"
          data-prefix="fab"
          data-icon="youtube"
          className="prefix__svg-inline--fa prefix__fa-youtube prefix__fa-w-18"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 576 512"
          {...props}
        >
          <path
            fill={props.fill}
            d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
          />
        </svg>
      )
}

export const YinYang = (props) => {
    return (
        <svg
          aria-hidden="true"
          data-prefix="fas"
          data-icon="yin-yang"
          className="prefix__svg-inline--fa prefix__fa-yin-yang prefix__fa-w-16"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 496 512"
          {...props}
        >
          <path
            fill={props.fill}
            d="M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 376c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-128c-53.02 0-96 42.98-96 96s42.98 96 96 96c-106.04 0-192-85.96-192-192S141.96 64 248 64c53.02 0 96 42.98 96 96s-42.98 96-96 96zm0-128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
          />
        </svg>
      )
}

export const Anchor = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="anchor"
      className="prefix__svg-inline--fa prefix__fa-anchor prefix__fa-w-18"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 576 512"
      {...props}
    >
      <path
        fill={props.fill}
        d="M12.971 352h32.394C67.172 454.735 181.944 512 288 512c106.229 0 220.853-57.38 242.635-160h32.394c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0l-67.029 67.029c-7.56 7.56-2.206 20.485 8.485 20.485h35.146c-20.29 54.317-84.963 86.588-144.117 94.015V256h52c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-52v-5.47c37.281-13.178 63.995-48.725 64-90.518C384.005 43.772 341.605.738 289.37.01 235.723-.739 192 42.525 192 96c0 41.798 26.716 77.35 64 90.53V192h-52c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v190.015c-58.936-7.399-123.82-39.679-144.117-94.015h35.146c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0L4.485 331.515C-3.074 339.074 2.28 352 12.971 352zM288 64c17.645 0 32 14.355 32 32s-14.355 32-32 32-32-14.355-32-32 14.355-32 32-32z"
      />
    </svg>
  )
}



export const Link = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="link"
      className="prefix__svg-inline--fa prefix__fa-link prefix__fa-w-16"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      {...props}
      
    >
      <path
        fill={props.fill}
        
        d="M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 01-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0120.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0020.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 00-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"
      />
    </svg>
  )
}



export const Design = (props) => { 
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="palette"
      className="prefix__svg-inline--fa prefix__fa-palette prefix__fa-w-16"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      {...props}
    >
      <path
        fill={props.fill}
        d="M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
      />
    </svg>
  )

}

export const Develope = (props) => { 
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="laptop-code"
      className="prefix__svg-inline--fa prefix__fa-laptop-code prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 512"
      {...props}
    >
      <path
         fill={props.fill}
        d="M255.03 261.65c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L253.25 192l35.71-35.72c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0l-58.34 58.34c-6.25 6.25-6.25 16.38 0 22.63l58.35 58.34zm96.01-11.3l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l58.34-58.34c6.25-6.25 6.25-16.38 0-22.63l-58.34-58.34c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L386.75 192l-35.71 35.72c-6.25 6.25-6.25 16.38 0 22.63zM624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
      />
    </svg>
  )

}

export const DownArrow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={512}
    height={512}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    {...props}
  >
    <path
      d="M511.5 41.5v188a28658.135 28658.135 0 0 1-246 247.5c-6.667 3.333-13.333 3.333-20 0A28663.876 28663.876 0 0 1-.5 229.5v-188c6.207-10.323 14.874-12.823 26-7.5a74717.704 74717.704 0 0 0 230 229.5A74717.704 74717.704 0 0 0 485.5 34c11.126-5.323 19.793-2.823 26 7.5Zm-480 46a64566.28 64566.28 0 0 1 214 213.5c6.667 3.333 13.333 3.333 20 0L479 87.5c.667 43 .667 86 0 129a70443.69 70443.69 0 0 1-223.5 223A70443.69 70443.69 0 0 1 32 216.5a8320.3 8320.3 0 0 1-.5-129Z"
      style={{
        opacity: 1
      }}
    />
  </svg>
)
